import addCheckpoint from '../history/add-checkpoint';
import validateEvent from '../helpers/validate-event';
import {
  INTERVAL_TO_CHECKPOINT,
  MAX_CONTENT_LENGTH,
  DISABLE_CHECKPOINT,
} from '../constants/common';

let timer = null;
let contentLength = null;
let isSaved = false;

const checkpointDelayHandler = (event) => {
  if (!validateEvent(event)) return;

  clearTimeout(timer);

  if (event[DISABLE_CHECKPOINT]) return;

  if (!isSaved) {
    addCheckpoint();
    isSaved = true;
  }

  timer = setTimeout(() => {
    isSaved = false;
    contentLength = null;
  }, INTERVAL_TO_CHECKPOINT);

  const { length } = event.srcElement.innerText;

  if (contentLength === null) {
    contentLength = length;
  }

  if (Math.abs(contentLength - length) >= MAX_CONTENT_LENGTH) {
    addCheckpoint();
    contentLength = null;
  }
};

export default checkpointDelayHandler;
